import React from 'react';

const EmptyExportsTable = () => (
  <div className="custom-exports-table-legacy-empty-state">
    <h2 className="text-quiet text-16 mb-mdl">Create your own custom export to get started</h2>
  </div>
);

export default EmptyExportsTable;
